import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

// Ícone "escolher um dado do fluxo": quadrado tracejado (seleção) + cursor.
// (o MUI v4 não tem HighlightAlt, então desenhamos.)
const PickVarIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <rect
      x="2.2"
      y="2.2"
      width="10.4"
      height="10.4"
      rx="2.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeDasharray="2.5 2.6"
      strokeLinecap="round"
    />
    <path d="M10.6 9.4 L11 21.7 L13.95 18.85 L16.25 23.5 L18.05 22.65 L15.75 18.05 L19.85 17.8 Z" />
  </SvgIcon>
);

export default PickVarIcon;
